// label 為 zh 後備文字；顯示時用 t(labelKey, label)
export const CLOSE_REASON_PLATFORMS = [
  { code: 'PLATFORM_OWN', labelKey: 'closeReasons.platformOwn', label: '本平台' },
  { code: 'PLATFORM_ONLINE', labelKey: 'closeReasons.platformOnline', label: '其他線上平台' },
  { code: 'PLATFORM_AGENCY', labelKey: 'closeReasons.platformAgency', label: '線下 agency' },
];

export const CLOSE_REASON_OTHERS = [
  { code: 'NO_SUITABLE', labelKey: 'closeReasons.noSuitable', label: '太長時間沒有心水人選' },
  { code: 'STOP_HIRING', labelKey: 'closeReasons.stopHiring', label: '不想再招聘' },
];
